import { render, staticRenderFns } from "./ModalHeaderWhite.vue?vue&type=template&id=234cc8ac&scoped=true&"
import script from "./ModalHeaderWhite.vue?vue&type=script&lang=js&"
export * from "./ModalHeaderWhite.vue?vue&type=script&lang=js&"
import style0 from "./ModalHeaderWhite.vue?vue&type=style&index=0&id=234cc8ac&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234cc8ac",
  null
  
)

export default component.exports